import { atomWithKey as atom } from "./atomWithKey";
import { ICmsDestination, ICmsDestinationDetail, IFamousPlace } from "../Types/Interface/ICmsDestination";
import { ICmsUsefulInformation } from "../Types/Interface/ICmsUsefulInformaton";
import { ICmsRoute } from "../Types/Interface/ICmsRoutes";
import { ICmsTrustBuilder } from "../Types/Interface/ICmsTrustBuilder";
import { ICMSNewsTypes } from "../Types/Interface/ICMSNews";
import { ICMSHomeBannerTypes } from "../Types/Interface/ICmsHomePageBanner";
import { IAppDownloadLink, ICmsAppDownloadLinkResponse } from "../Types/Interface/ICmsAppDownloadLink";
import { ICmsEnhancedTrips } from "../Types/Interface/ICmsEnhancedTrip";
import { IFavouriteTrips } from "../Types/Interface/IFavouriteTrips";
import { IFavouriteDepartures } from "../Types/Interface/IFavouriteDepartures";
import { IPopularTripsForHomePage } from "../Types/Interface/ICmsPopularTrip";
import { IDepartureFromTrips } from "../Types/Interface/IDepartureFromTrips";
import { ITodayTrainFromTrips } from "../Types/Interface/ITodayTrainFromTrips";
import { ICMSStops } from "../Types/Interface/ICmsStops";

export const destinationResponseAtom = atom<ICmsDestination[]>({
  key: "destinationResponseAtom",
  default: [],
});

export const destinationDetailAtom = atom<ICmsDestination | null>({
  key: "destinationDetailAtom",
  default: null,
});

export const usefulInformationAtom = atom<ICmsUsefulInformation[]>({
  key: "usefulInformationAtom",
  default: [],
});

export const routesResponseAtom = atom<ICmsRoute[]>({
  key: "routesResponseAtom",
  default: [],
});

export const trustBuildersResponseAtom = atom<ICmsTrustBuilder[]>({
  key: "trustBuildersResponseAtom",
  default: [],
});

export const newsListResponseAtom = atom<ICMSNewsTypes[]>({
  key: "newsListResponseAtom",
  default: [],
});


export const newsDetailResponseAtom = atom<ICMSNewsTypes | null>({
  key: "newsDetailResponseAtom",
  default: null,
});


export const cmsPLaceDetailAtom = atom<IFamousPlace | null>({
  key: "cmsPLaceDetailAtom",
  default: null,
});

export const bannerListResponseAtom = atom<ICMSHomeBannerTypes[] | null>({
  key: "bannerListResponseAtom",
  default: null,
});

export const cmsAppDownloadLinkResponseAtom = atom<ICmsAppDownloadLinkResponse | null>({
  key: "cmsAppDownloadLinkResponseAtom",
  default: null,
});

export const appDownloadLinkAtom = atom<IAppDownloadLink | null>({
  key: "appDownloadLinkAtom",
  default: null,
});

export const enhancedTripsResponseAtom = atom<ICmsEnhancedTrips[]>({
  key: "enhancedTripsResponseAtom",
  default: [],
});

export const enhancedTripDetailAtom = atom<ICmsEnhancedTrips | null>({
  key: "enhancedTripDetailAtom",
  default: null,
});

export const usefulInfoDetailAtom = atom<ICmsUsefulInformation | null>({
  key: "usefulInfoDetailAtom",
  default: null,
});


export const favouriteTripsForTodayResponseAtom = atom<IFavouriteTrips[]>({
  key: "favouriteTripsForTodayResponseAtom",
  default: [],
});

export const departureFromTripsAtom = atom<IDepartureFromTrips[]>({
  key: "departureFromTripsAtom",
  default: [],
});

export const todayTrainFromTripsAtom = atom<ITodayTrainFromTrips[]>({
  key: "todayTrainFromTripsAtom",
  default: [],
});

export const favouriteDeparturesForTodayResponseAtom = atom<IFavouriteDepartures[]>({
  key: "favouriteDeparturesForTodayResponseAtom",
  default: [],
});

export const popularTripsForHomePageAtom = atom<IPopularTripsForHomePage[]>({
  key: "popularTripsForHomePageAtom",
  default: [],
});

// Distinct origin station IDs that appear in the /best-prices response.
// Used to filter the "Departures from" widget's city dropdown so users
// only see stations that actually have a best-price entry.
export const bestPriceAvailableOriginsAtom = atom<string[]>({
  key: "bestPriceAvailableOriginsAtom",
  default: [],
});

export const cmsStopsAtom = atom<ICMSStops[]>({
  key: "cmsStopsAtom",
  default: [],
});

// Per-section "has the first fetch settled?" flags for the landing page.
// false = still loading (show skeleton). Ephemeral — never whitelisted/persisted.
export const newsLoadedAtom = atom<boolean>({ key: "newsLoadedAtom", default: false });
export const routesLoadedAtom = atom<boolean>({ key: "routesLoadedAtom", default: false });
export const popularTripsLoadedAtom = atom<boolean>({ key: "popularTripsLoadedAtom", default: false });
export const popularDestinationsLoadedAtom = atom<boolean>({ key: "popularDestinationsLoadedAtom", default: false });